export default __webpack_public_path__ + "static/media/emergency.8e6f3afb.gif";